export default __webpack_public_path__ + "static/media/ic-exported-2.fc32760a.svg";